import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
`

/** @component */
export default Wrapper
